<template>
<Wrapper
    v-show="
      component &&
      !preview && renderTools &&
      ![
        'reheight_widget',
        'remargin_widget',
        'crop_image',
        'sort_widget',
      ].includes(mode) &&
      parentWidgetActive.id
    "
    :position="parentWidgetActive.position"
    :parentWidget="true"
    id="parent-widget-active"
>
    <WidgetHover 
    :class="getParentClass()" 
    :style="positionParent"
    @click="goToWidgetParent()"
    >
      {{ widgetTypeShow }}
    </WidgetHover>
</Wrapper>
  
</template>

<script>
import { mapGetters } from "vuex";
import { Wrapper} from "./WidgetActive.styled";
import { WidgetHover } from "./WidgetHover.styled";

import { WIDGET } from "@model/components/componentMeta.model";

export default {
    components:{
        Wrapper,
        WidgetHover
    },
    computed:{
        ...mapGetters({
            parentWidgetActive: "designIframe/frame/parentWidgetActive",
            component: "designIframe/component/component",
            widgetActive: "designIframe/frame/widgetActive",
            components: "designIframe/metadata/components",
            preview: "designIframe/preview",
            mode: "designIframe/mode",
            renderTools: "designIframe/frame/renderTools",
        }),
        component() {
            return this.components[this.parentWidgetActive.id];
        },
        widgetType() {
            return this.component && this.component.type;
        },
        widgetTypeShow() {
            if(!this.widgetType) return "";
            let type = "";
            switch (this.widgetType) {
                case "SECTION_WIDGET_LINE_SEPARATE":
                type = "line";
                break;
                case "HEADER_WIDGET_MENU":
                type = "Header Menu";
                break;
                case "HEADER_WIDGET_LOGO":
                type = "Logo";
                break;
                case "HEADER_WIDGET_MEMBER":
                type = "Member";
                break;
                case "HEADER_WIDGET_SOCIAL":
                type = "Social";
                break;
                case "HEADER_WIDGET_LANGUAGE":
                type = "Language";
                break;
                case "HEADER_WIDGET_CURRENCY":
                type = "Currency";
                break;
                case "HEADER_WIDGET_SEARCH":
                type = "Search";
                break;
                case "HEADER_WIDGET_TEXT":
                type = "Text";
                break;
                case "HEADER_WIDGET_TOPMENU":
                type = "Top Menu";
                break;
                case "HEADER_WIDGET_CART":
                type = "Cart";
                break;
                case "FOOTER_WIDGET_MENU":
                type = "Footer Menu";
                break;
                case "FOOTER_WIDGET_LOGO":
                type = "Logo";
                break;
                case "FOOTER_WIDGET_SUBSCRIBE":
                type = "Subscribe";
                break;
                case "FOOTER_WIDGET_SOCIAL":
                type = "Social";
                break;
                case "FOOTER_WIDGET_PARTNER":
                type = "Partner";
                break;
                case "FOOTER_WIDGET_COPYRIGHT":
                type = "Copyright";
                break;
                case "FOOTER_WIDGET_STATCOUNTER":
                type = "Stat Counter";
                break;
                case "FOOTER_WIDGET_TEXT1":
                type = "Text";
                break;
                case "FOOTER_WIDGET_TEXT2":
                type = "Text";
                break;
                case "FOOTER_WIDGET_TEXT3":
                type = "Text";
                break;
                case "FOOTER_WIDGET_TEXT4":
                type = "Text";
                break;
                default:
                type = this.widgetType.replace(WIDGET.prefixType, "")
                break;
            }
            return this.$helper.text.capitalize(type);
        },
        indexWidgetChild() {
            return this.component && this.component.componentsID.indexOf(this.widgetActive.id);
        },
        isFirstIndexChild() {
            return this.indexWidgetChild == 0;
        },
        isWidgetOverlapParent() {
            if (!this.widgetActive || !this.parentWidgetActive || !this.isFirstIndexChild ) return false;
            const a = this.widgetActive.position;
            const b = this.parentWidgetActive.position;
            if (!a || !b) return false;
            const aTop = parseFloat(a.top);
            const aLeft = parseFloat(a.left);
            const aWidth = parseFloat(a.width);
            const aHeight = parseFloat(a.height);
            const bTop = parseFloat(b.top);
            const bLeft = parseFloat(b.left);
            const bWidth = parseFloat(b.width);
            const bHeight = parseFloat(b.height);
            // ตรวจสอบการ overlap
            const overlap = !(
                aLeft + aWidth < bLeft ||
                aLeft > bLeft + bWidth ||
                aTop + aHeight < bTop ||
                aTop > bTop + bHeight
            );
            return overlap;
        },
        positionParent() {
            return '';
            //return this.isWidgetOverlapParent ? 'top: 100%; bottom: unset;' : 'top: unset; bottom: 100%;';
        },
        isHeaderWidget() {
            return this.component && this.component.type.includes("HEADER_WIDGET") ? true : false
        },
        isFooterWidget() {
            return this.component && this.component.type.includes("FOOTER_WIDGET") ? true : false
        },
        grid_id() {
            return this.cell_id && !this.isHeaderWidget && !this.isFooterWidget && Object.entries(this.components).filter(
                (item) =>
                item[1].componentsID &&
                item[1].componentsID.includes(this.cell_id)
            )[0][0];
        },
        cell_id() {
            return this.component && !this.isHeaderWidget && !this.isFooterWidget && Object.entries(this.components).filter(
                (item) =>
                item[1].componentsID &&
                item[1].componentsID.includes(this.component.id)
            )[0][0];
        }
    },
    methods : {
      async goToWidgetParent(){
            if(this.widgetType=='SECTION_WIDGET_BUTTON_GROUP'){
                await this.$store.dispatch("designIframe/frame/setWidgetActive", {
                    grid_id: this.grid_id,
                    cell_id: this.cell_id,
                    component_id: this.component.id,
                });
                this.$store.dispatch("designIframe/component/elActive", {
                    elementID: ["component", this.component.id],
                });
                await this.$store.dispatch("designIframe/frame/setParentWidgetActive", {
                    component_id: this.component.id,
                });
            }
        },
        getParentClass(){
            let classParent = 'label-name-frame ';
            const hasComponentsID = this.component 
                && Array.isArray(this.component.componentsID) 
                && this.component.componentsID.includes(this.widgetActive.id);
            const hasComponentsIDHover = this.component 
                && Array.isArray(this.component.componentsIDHover) 
                && this.component.componentsIDHover.includes(this.widgetActive.id);
            if (
                this.component && 
                (hasComponentsID || hasComponentsIDHover)
                && this.component.type != 'SECTION_WIDGET_BUTTON_GROUP'
            ) {
                return classParent + 'parent-active';
            } else if (this.parentWidgetActive && this.parentWidgetActive.id && this.component && this.component.type === 'SECTION_WIDGET_BUTTON_GROUP') {
                return classParent + 'parent-group-active';
            } else if (this.parentWidgetActive && this.parentWidgetActive.id) {
                return classParent + 'active';
            } else {
                return classParent + 'disabled';
            }
            // let classParent = 'label-name-frame '
            // if(
            //     this.component && 
            //     (
            //         this.component.componentsID.includes(this.widgetActive.id) || 
            //         this.component.componentsIDHover.includes(this.widgetActive.id)
            //     )
            //     && this.component.type != 'SECTION_WIDGET_BUTTON_GROUP'
            // ){
            //     return classParent + 'parent-active'
            // }else if(this.parentWidgetActive.id && this.component.type === 'SECTION_WIDGET_BUTTON_GROUP'){
            //     return classParent + 'parent-group-active'
            // }else if(this.parentWidgetActive.id){
            //     return classParent + 'active'
            // }else{
            //     return classParent + 'disabled'
            // }
        }
    }
}
</script>


<style>

</style>